import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    bindNotice: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 36,
        paddingLeft: 12,
        paddingRight: 12,
        backgroundColor: '#fefcec',
        zIndex: 2,
    },
    bindNoticeLeft: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    noticeIcon: {
        marginRight: 4,
        width: 20,
        height: 20,
        fontSize: 20,
        color: '#ff9800'
    },
    bindNoticeRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    bindNoticeText: {
        fontSize: 13,
        color: '#595452'
    },
    bindNoticeIcon: {
        width: 16,
        height: 16,
        fontSize: 16,
        color: '#595452'
    }
});
